module.exports = __webpack_public_path__ + "img/spetema.e3271151.png";